import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type Props = {
	onClose: () => void;
	onNext: () => void;
	canContinue: boolean;
};

export const PickCountryStepActions = ({
	onClose,
	onNext,
	canContinue
}: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<Button variant='text' onClick={onClose}>
				{t('Cancel')}
			</Button>
			<Button disabled={!canContinue} variant='contained' onClick={onNext}>
				{t('Next')}
			</Button>
		</>
	);
};
